import { render } from "./RequestDailyAbsenceDetails.vue?vue&type=template&id=2d787872&scoped=true"
import script from "./RequestDailyAbsenceDetails.vue?vue&type=script&lang=js"
export * from "./RequestDailyAbsenceDetails.vue?vue&type=script&lang=js"

import "./RequestDailyAbsenceDetails.vue?vue&type=style&index=0&id=2d787872&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d787872"]])

export default __exports__